import { createSvgIcon } from '@material-ui/core';

export const GroupIcon = createSvgIcon(
  <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.0234 15.9C26.0234 19.7108 22.8859 22.8 19.0156 22.8C15.1453 22.8 12.0078 19.7108 12.0078 15.9C12.0078 12.0892 15.1453 9 19.0156 9C22.8859 9 26.0234 12.0892 26.0234 15.9ZM5 37.8C5 31.1726 10.4565 25.8 17.1875 25.8H20.8438C27.5747 25.8 33.0312 31.1726 33.0312 37.8V39H5V37.8ZM29.9844 22.8C28.8924 22.8 27.8588 22.5541 26.9375 22.1155C29.2816 20.9994 30.8984 18.6356 30.8984 15.9C30.8984 13.1644 29.2816 10.8006 26.9375 9.68455C27.8588 9.24591 28.8924 9 29.9844 9C33.8547 9 36.9922 12.0892 36.9922 15.9C36.9922 19.7108 33.8547 22.8 29.9844 22.8ZM44 39H37.9062V37.8C37.9062 31.5776 33.0962 26.4613 26.9375 25.8593C27.3384 25.8201 27.7449 25.8 28.1562 25.8H31.8125C38.5435 25.8 44 31.1726 44 37.8V39Z"
      fill="currentColor"
    />
  </svg>,
  'GroupIcon',
);
